export const translations = {
  es: {
    nav: {
      marketplace: "Marketplace",
      shop: "Tienda",
      breeders: "Criadores",
      merch: "Ropa",
      admin: "Admin",
      cart: "Carrito",
      wishlist: "Favoritos",
      signin: "Entrar",
      signout: "Cerrar sesión",
      account: "Mi cuenta",
    },
    home: {
      eyebrow: "MONZAL · GENÉTICA DE ÉLITE",
      headlineA: "Sangre antigua.",
      headlineB: "Futuro exótico.",
      sub: "Reptiles exóticos de linaje verificado. Tecnología de cuidado de nivel laboratorio. Estética de culto. Pasión sin límites.",
      ctaExplore: "Explorar Marketplace",
      ctaShop: "Ver Tienda",
      featuredEyebrow: "DROP ACTUAL",
      featuredTitle: "Ejemplares destacados",
      featuredSub: "Animales elegidos uno por uno por nuestro equipo. Disponibilidad muy limitada.",
      categoriesEyebrow: "EXPLORA",
      categoriesTitle: "Nuestras categorías",
      catSnakes: "Serpientes",
      catLizards: "Lagartos",
      catVenom: "Veneno",
      catRacks: "Racks & Terrarios",
      catAccessories: "Accesorios",
      catMerchTitle: "Merch",
      viewCollection: "Ver colección",
      viewProducts: "Ver productos",
      viewAll: "Ver todo",
      trustVerified: "Genética verificada",
      trustRare: "Linaje exclusivo",
      trustShipping: "Envío blindado",
      trustSupport: "Soporte experto",
      utilityA: "GENÉTICA DE ÉLITE",
      utilityB: "LINAJE VERIFICADO",
      utilityC: "CRIADOS EN MÉXICO",
      live: "EN VIVO",
      bentoMarketplace: "Marketplace",
      bentoMarketplaceSub: "Morfos raros. Filtros precisos.",
      bentoEnclosures: "Terrarios",
      bentoEnclosuresSub: "Hábitats de diseño",
      bentoMerch: "Ropa",
      bentoMerchSub: "Apparel oficial",
      bentoBreeders: "Criadores",
      bentoBreedersSub: "Linaje verificado",
      breedersTitle: "Criadores Selectos",
      breedersSub: "Tres casas que están definiendo la genética premium en México.",
      manifestoTitle: "Diseñado como una pieza de tecnología.\nCriado como una reliquia.",
      manifestoBody: "Cada animal en MONZAL pasa por una evaluación de genética, salud y temperamento. Cada accesorio es ingeniería minimalista. Esto no es una tienda de mascotas: es una declaración.",
      footerCta: "Súmate al club",
      footerCtaSub: "Acceso anticipado a lanzamientos, nueva genética y eventos privados.",
    },
    market: {
      title: "Marketplace",
      sub: "Reptiles de élite con genética y procedencia verificadas.",
      filters: "Filtros",
      species: "Especie",
      morph: "Morfo",
      sex: "Sexo",
      price: "Precio",
      priceUnit: "(MXN)",
      sort: "Ordenar",
      sortNewest: "Más recientes",
      sortPriceAsc: "Precio: menor a mayor",
      sortPriceDesc: "Precio: mayor a menor",
      sexMale: "Macho",
      sexFemale: "Hembra",
      sexUnsexed: "Sin sexar",
      sexAny: "Todos",
      anyOption: "Todos",
      clear: "Limpiar filtros",
      noResults: "No encontramos ejemplares con esos filtros.",
      results: "ejemplares",
    },
    detail: {
      genetics: "Genética",
      hets: "Hets",
      sex: "Sexo",
      weight: "Peso",
      hatch: "Fecha de nacimiento",
      feeding: "Alimentación",
      age: "Edad",
      months: "meses",
      breederNotes: "Notas del criador",
      addToCart: "Añadir al carrito",
      reserve: "Apartar",
      makeOffer: "Hacer oferta",
      wishlist: "Favoritos",
      species: "Especie",
      gallery: "Galería",
      back: "Volver",
      breederBy: "Criadero",
      relatedTitle: "Otros ejemplares",
    },
    shop: {
      title: "Tienda",
      sub: "Accesorios premium, terrarios de diseño y ropa oficial.",
      all: "Todo",
      accessories: "Accesorios",
      enclosure: "Terrarios",
      food: "Alimento",
      merch: "Ropa",
      addToCart: "Añadir al carrito",
      buyNow: "Comprar",
    },
    cart: {
      title: "Tu carrito",
      empty: "Tu carrito está vacío.",
      exploreCta: "Explorar Marketplace",
      subtotal: "Subtotal",
      checkout: "Ir a pagar",
      remove: "Quitar",
      qty: "Cant.",
      method: "Método de pago",
      methodCard: "Tarjeta",
      methodOxxo: "OXXO",
    },
    checkout: {
      success: "Pago confirmado",
      successSub: "Gracias por tu compra. Estamos preparando tu pedido.",
      checking: "Verificando el pago…",
      failed: "El pago no se completó",
      backHome: "Volver al inicio",
      orderSummary: "Resumen del pedido",
    },
    breeder: {
      verified: "Verificado",
      yearsActive: "años de experiencia",
      specialties: "Especialidades",
      animals: "Ejemplares disponibles",
    },
    admin: {
      title: "Panel de administración",
      sub: "Administra el catálogo de MONZAL.",
      stats: "Estadísticas",
      reptiles: "Reptiles",
      products: "Productos",
      breeders: "Criadores",
      users: "Usuarios",
      orders: "Pedidos",
      revenue: "Ingresos",
      newReptile: "Nuevo ejemplar",
      newProduct: "Nuevo producto",
      title_field: "Título",
      species_field: "Especie",
      morph_field: "Morfo",
      price_field: "Precio (MXN)",
      sex_field: "Sexo",
      weight_field: "Peso (g)",
      hatch_field: "Fecha de nacimiento",
      genetics_field: "Genética (separa con comas)",
      hets_field: "Hets (separa con comas)",
      breeder_field: "Criadero",
      notes_field: "Notas",
      cover_field: "URL de portada",
      gallery_field: "URLs de la galería (separa con comas)",
      featured_field: "Destacado",
      save: "Guardar",
      saving: "Guardando…",
      category_field: "Categoría",
      description_field: "Descripción",
      stock_field: "Existencias",
      uploadImage: "Subir imagen",
      listings: "Listados",
      delete: "Eliminar",
      seed: "Reiniciar datos demo",
    },
    auth: {
      signIn: "Entrar con Google",
      welcome: "Bienvenido a MONZAL",
      welcomeSub: "Inicia sesión para guardar favoritos, completar tus compras y subir tus ejemplares como criadero.",
    },
    common: {
      from: "desde",
      sold: "Vendido",
      reserved: "Apartado",
      available: "Disponible",
      featured: "Destacado",
    },
  },
  en: {
    nav: {
      marketplace: "Marketplace",
      shop: "Shop",
      breeders: "Breeders",
      merch: "Merch",
      admin: "Admin",
      cart: "Cart",
      wishlist: "Wishlist",
      signin: "Sign in",
      signout: "Sign out",
      account: "Account",
    },
    home: {
      eyebrow: "MONZAL · ELITE GENETICS",
      headlineA: "Ancient blood.",
      headlineB: "Exotic future.",
      sub: "Exotic reptiles with verified lineage. Lab-grade care technology. Cult aesthetics. Limitless passion.",
      ctaExplore: "Enter Marketplace",
      ctaShop: "Shop",
      featuredEyebrow: "CURRENT DROP",
      featuredTitle: "Featured reptiles",
      featuredSub: "Hand-picked by our curators. Extremely limited quantities.",
      categoriesEyebrow: "EXPLORE",
      categoriesTitle: "Our categories",
      catSnakes: "Snakes",
      catLizards: "Lizards",
      catVenom: "Venom",
      catRacks: "Racks & Enclosures",
      catAccessories: "Accessories",
      catMerchTitle: "Merch",
      viewCollection: "View collection",
      viewProducts: "View products",
      viewAll: "View all",
      trustVerified: "Verified genetics",
      trustRare: "Rare lineage",
      trustShipping: "Armored shipping",
      trustSupport: "Expert support",
      utilityA: "ELITE GENETICS",
      utilityB: "VERIFIED LINEAGE",
      utilityC: "BRED IN MEXICO",
      live: "LIVE",
      bentoMarketplace: "Marketplace",
      bentoMarketplaceSub: "Rare genetics. Precise filters.",
      bentoEnclosures: "Enclosures",
      bentoEnclosuresSub: "Designer habitats",
      bentoMerch: "Merch",
      bentoMerchSub: "Ritual apparel",
      bentoBreeders: "Breeders",
      bentoBreedersSub: "Verified lineage",
      breedersTitle: "Curated breeders",
      breedersSub: "Three houses defining premium genetics in Mexico.",
      manifestoTitle: "Engineered like a piece of technology.\nRaised like a relic.",
      manifestoBody: "Every animal in MONZAL passes through genetic, health and temperament evaluation. Every accessory is minimalist engineering. This is not a pet store. It is a statement.",
      footerCta: "Join the ritual",
      footerCtaSub: "Priority access to drops, raw genetics and private events.",
    },
    market: {
      title: "Marketplace",
      sub: "Elite reptiles with verified genetics and provenance.",
      filters: "Filters",
      species: "Species",
      morph: "Morph",
      sex: "Sex",
      price: "Price",
      priceUnit: "(MXN)",
      sort: "Sort",
      sortNewest: "Newest",
      sortPriceAsc: "Price ascending",
      sortPriceDesc: "Price descending",
      sexMale: "Male",
      sexFemale: "Female",
      sexUnsexed: "Unsexed",
      sexAny: "Any",
      anyOption: "Any",
      clear: "Clear",
      noResults: "No specimens match your criteria.",
      results: "specimens",
    },
    detail: {
      genetics: "Genetics",
      hets: "Hets",
      sex: "Sex",
      weight: "Weight",
      hatch: "Hatch date",
      feeding: "Feeding",
      age: "Age",
      months: "months",
      breederNotes: "Breeder notes",
      addToCart: "Add to cart",
      reserve: "Reserve",
      makeOffer: "Make offer",
      wishlist: "Wishlist",
      species: "Species",
      gallery: "Gallery",
      back: "Back",
      breederBy: "Breeder",
      relatedTitle: "Other specimens",
    },
    shop: {
      title: "Shop",
      sub: "Premium accessories, designer enclosures and ritual merch.",
      all: "All",
      accessories: "Accessories",
      enclosure: "Enclosures",
      food: "Food",
      merch: "Merch",
      addToCart: "Add to cart",
      buyNow: "Buy",
    },
    cart: {
      title: "Your cart",
      empty: "Your cart is empty.",
      exploreCta: "Enter marketplace",
      subtotal: "Subtotal",
      checkout: "Proceed to payment",
      remove: "Remove",
      qty: "Qty",
      method: "Payment method",
      methodCard: "Card",
      methodOxxo: "OXXO",
    },
    checkout: {
      success: "Payment confirmed",
      successSub: "Thank you. Your order is being processed.",
      checking: "Verifying payment…",
      failed: "Payment not completed",
      backHome: "Back to home",
      orderSummary: "Order summary",
    },
    breeder: {
      verified: "Verified",
      yearsActive: "years breeding",
      specialties: "Specialties",
      animals: "Available specimens",
    },
    admin: {
      title: "Admin Panel",
      sub: "Manage the MONZAL catalogue.",
      stats: "Statistics",
      reptiles: "Reptiles",
      products: "Products",
      breeders: "Breeders",
      users: "Users",
      orders: "Orders",
      revenue: "Revenue",
      newReptile: "New reptile",
      newProduct: "New product",
      title_field: "Title",
      species_field: "Species",
      morph_field: "Morph",
      price_field: "Price (MXN)",
      sex_field: "Sex",
      weight_field: "Weight (g)",
      hatch_field: "Hatch date",
      genetics_field: "Genetics (comma)",
      hets_field: "Hets (comma)",
      breeder_field: "Breeder",
      notes_field: "Notes",
      cover_field: "Cover URL",
      gallery_field: "Gallery URLs (comma)",
      featured_field: "Featured",
      save: "Save",
      saving: "Saving…",
      category_field: "Category",
      description_field: "Description",
      stock_field: "Stock",
      uploadImage: "Upload image",
      listings: "Listings",
      delete: "Delete",
      seed: "Re-seed mock data",
    },
    auth: {
      signIn: "Sign in with Google",
      welcome: "Welcome to MONZAL",
      welcomeSub: "Sign in to save favorites, complete purchases, and upload your specimens as a breeder.",
    },
    common: {
      from: "from",
      sold: "Sold",
      reserved: "Reserved",
      available: "Available",
      featured: "Featured",
    },
  },
};

export const t = (lang, key) => {
  const parts = key.split(".");
  let cur = translations[lang] || translations.en;
  for (const p of parts) {
    cur = cur?.[p];
    if (cur == null) return key;
  }
  return cur;
};
